module.exports = __webpack_public_path__ + "flyer_background_confetti_yay_084-ad1277fda7ef28b4a5d4c79487040ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_confetti_yay_084.jpg
// module id = 1630
// module chunks = 1